export default {
  newDesign: true,
  parameters: {
    landing_id: "UKLQDev",
    segment: 3,
    success_page: "success_long_new_design"
  },
  title: "Your child can learn programming from home, in a fun way | Kodland",
  downtimeUrl: "https://www.kodland.org",
  startPage: {
    title:
      "Answer the questions to sign up for your first trial class.",
    subtitle:
      "We turn passion for technology into an advantage:<br>💬  Discover your child’s talents in a fun way<br>🌐 You only need a computer and internet connection<br>💙 More than 270 kids enrolled just today		",
    image: {
      url: "/welcome/uk_longquiz_dev_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/uk_longquiz_dev_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Let’s get started today 🔥",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Thank you for your interest in Kodland. Our online courses are designed for children aged 8 to 17.",
    subtitle: "Please note that our courses require a keyboard and mouse; therefore, phones, tablets, and devices without these features are not compatible.<br>If you do have a laptop, please resubmit the form via this link <a target=\"_blank\" href=\"https://mrqz.me/66c7170aca95fe0026c5a69c?roistat_visit=9376\">this link</a>, or contact us at +447700182949💙",
  },
  quizRotateBySteps: {
    1: {
      title: "How old is your child?",
      type: "age",
      button: "",
    },
    2: {
      question: "What does your child like to do in their free time?",
      answers: [
        "Play sports or outdoor games ⚽",
        "Read books or comics 📚",
        "Watch TV, YouTube, or play video games 🎮",
        "Spend time with friends or family 👫",
        "Other 🙂"
      ],
    },
    3: {
      question: "How does your child feel about online learning?",
      answers: [
        "They love it and find it interesting 💻",
        "They prefer in-person learning 🙂",
        "They have trouble staying focused 😬",
        "They’ve never tried online learning ❓"
      ],
    },
    4: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/uk_screen_time.png",
      subtitle: "Although it is recommended that children do not spend more than 2 hours a day in front of screens, in reality they usually exceed this time. That’s why it’s ideal to alternate entertainment with productive activities, such as lessons lasting 1 to 1.5 hours.<br>Our programs are designed with this in mind.",
      button: "Very good ✅",
    }, 5: {
      question: "At school, what does your child enjoy the most?",
      answers: [
        "Science or math 🧪🔢",
        "Reading and writing stories 📚✍️",
        "Art, music, or creative activities 🎨🎶",
        "Physical education or sports 🏃‍♂️⚽",
        "Other 🙂"
      ],
    },
    6: {
      question: "Does your child like building or designing things (for example, with Lego, art, puzzles)?",
      answers: [
        "Yes, they love building and designing things 🌿🏗️",
        "Sometimes, but they prefer other activities 🤔",
        "No, they’re not very interested in that 🙇"
      ],
    },
    7: {
      question: "How does your child learn or remember new things best?",
      answers: [
        "By seeing (visual learning) 👁️",
        "By doing (hands-on learning) ✋",
        "By listening (auditory learning) 🎧",
        "Through repetition and practice ✏️"
      ],
    },
    8: {
      question: "Does your child have access to a laptop or desktop PC for studying?",
      answers: [
        "Yes, they have their own device 💻✅",
        "Yes, but they share it with other people 🖥️👫",
        {
          answer: "No, they don’t have regular access 🚫",
          stopAnswer: true,
        },
      ],
    },
    9: {
      question: "What type of activities or hobbies attract your child the most?",
      answers: [
        "Sports or dance ⚽",
        "Creative arts 🎨✏️",
        "Drawing, painting, or crafts 🍀♟️🖥️",
        "Video games or watching videos 🎮🖥️",
        "Other 🙂"
      ],
    },
    10: {
      question: "How does your child act when working in a group?",
      answers: [
        "They like to collaborate 🤝💡",
        "They prefer to lead 🧑‍🏫",
        "They work independently, but contribute 🧍‍♂️✔️",
        "They feel shy or uncomfortable 😳"
      ],
    },
    11: {
      question: "What role does your child usually take in group activities?",
      answers: [
        "They like to lead and organize 🧑‍🏫📋",
        "They like to contribute ideas and collaborate 🤝💡",
        "They prefer to listen and follow 👂🙂",
        "They try to mediate or resolve conflicts ⚖️🕊️",
        "They feel shy and stay in the background 😳"
      ],
    },
    12: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/quiz_br_2.webp",
      subtitle: "We offer both individual and group learning formats, adapting the process according to each child’s age to make it as personalized as possible.",
      button: "Let’s get started!",
    }, 13: {
      question: "Has your child shown interest in learning programming?",
      answers: [
        "Yes, they have already started learning 💻🚀",
        "Yes, they are curious but haven’t tried yet 🤔💡",
        "Not yet, but maybe they will get interested 🧑‍🎓",
        "No, they are not interested 🙅"
      ],
    },
    14: {
      question: "When does your child feel most comfortable and happy?",
      answers: [
        "When playing with friends or family 👫❤️",
        "When exploring new things or learning ✨🔍",
        "When creating or building something 🛠️✨",
        "When having a quiet moment 🤫📖"
      ],
    },
    15: {
      question: "What activities or subjects does your child enjoy the most?",
      answers: [
        "Reading or writing 📚✍️",
        "Art, music, or theater 🎨🎶🎭",
        "Sports or physical activities 🏃‍♂️⚽",
        "Technology or computing 💻📱",
        "Other 🙂"
      ],
    },
    16: {
      question: "Does your child like to create things or do activities with friends?",
      answers: [
        "Yes, they love group creative projects 👫🎨",
        "Sometimes, depending on the activity 🤔",
        "No, they prefer individual tasks 🧍💡"
      ],
    },
    17: {
      question: "Does your child feel comfortable using technology such as computers, apps, or basic tasks on the internet?",
      answers: [
        "Very comfortable, they use it frequently 💻✅",
        "They can do tasks, but need help 🖱️❓",
        "They are not familiar with it 🚫"
      ],
    },

    18: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/uk_before_after.png",
      subtitle: "At Kodland, students design 3D models, create comics, develop games, and learn programming. Currently, more than 30,000 children worldwide are learning with us!",
      button: "Great ✅",
    },
    19: {
      question: "How does your child handle challenges or problems?",
      answers: [
        "They try to solve it on their own 💪🧠",
        "They ask for help when necessary 🙋✔️",
        "They get frustrated and give up easily 😣",
        "They see problems as a challenge 🧑‍🏫"
      ],
    },
    20: {
      question: "Does your child show interest in creating their own stories or characters?",
      answers: [
        "They love telling stories and have ideas ✍️",
        "Sometimes, but they need encouragement 🙂",
        "No, they are not very interested in that 🚫"
      ],
    },
    21: {
      question: "How does your child handle tasks that require attention and logical thinking?",
      answers: [
        "They focus and solve problems 🎯🍀",
        "They perform well with guidance 📋🤝",
        "They have difficulty with detailed tasks 😅"
      ],
    },
    22: {
      question: "When your child tells a story, they usually…",
      answers: [
        "Focus on details 🧵📜",
        "Go straight to the main point 🎯",
        "Add humor or imagination 🤹✨",
        "Struggle to organize their thoughts 🤔"
      ],
    },
    23: {
      question: "How does your child react when trying something new?",
      answers: [
        "They jump in with enthusiasm 🎉🚀",
        "They are curious but cautious 🤔👣",
        "They feel nervous and need support 😬🙋",
        "They love experimenting 🛠️🧪",
        "They resist trying new things 🙅"
      ],
    },
    24: {
      question: "Does your child prefer to follow instructions or create their own ideas?",
      answers: [
        "They like clear instructions ✔️",
        "They prefer creative ideas and new approaches 🎨",
        "They like a mix of structure and freedom 🛠️",
        "It depends on the task: structure or creativity 🧑‍🎓"
      ],
    },

    25: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/uk_reviews.png",
      subtitle: "Parents from all over the world recommend us. We hope you will join them soon! 💙",
      button: "We’re almost done ✅",
    },
    26: {
      question: "What motivates your child to stay focused on a task?",
      answers: [
        "A clear goal or reward at the end 🎯🏅",
        "Excitement or passion for the task ✨❤️",
        "Working in a group 🤝💬",
        "Receiving motivation during the process 👏🙂",
        "Feeling it’s a challenge or competition 🏅🔥"
      ],
    },
    27: {
      question: "What type of stories or topics does your child like to talk about?",
      answers: [
        "Science, technology or inventions 🧪🛠️",
        "Science, technology or discoveries 🧬💻",
        "Funny or comic stories 🤪😂",
        "Real events or history 📜🌍",
        "Stories about friendships or emotions ❤️👫"
      ],
    },
    28: {
      question: "What makes your child feel proud or accomplished?",
      answers: [
        "Completing a challenging task 🏆🧠",
        "Helping others or contributing 🤝❤️",
        "Learning something new 📚✨",
        "Receiving positive feedback 🥳👏",
        "Solving a complicated problem 🔍🍀"
      ],
    },

    29: {
      title: "🎉 Just one more step!",
      typeInfo: "congrats",
      subtitle:
        "Help your child explore their creative side with programming and digital design.<br>🌟 More than 200,000 kids are already creating and learning with us.",
      button: "📅 Book a free class!",
    },
    30: {
      title: "🎉 Register for a free trial class",
      type: "one-page-contacts",
      subtitle: "Your child will create a mini-game in the first lesson. And you can join too!",
      button: "✨ Perfect! Just one more step.",
    },
    31: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    32: {
      title:
        "Check out this information to complete the registration ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Please ensure you have a working computer or laptop available for the lesson. It’s also important that you accompany your child during the class. Each session is personalized and tailored to your child's needs.",
      button: "What else?",
    },
    33: {
      title: "Before the trial, check your email and WhatsApp for updates 📞",
      typeInfo: "whatsapp",
      subtitle:
        "We'll send you a reminder 24 hours before the class and will request confirmation of your attendance 2 hours prior to the start time. Staying in touch is essential to avoid class cancellation.",
      button: "Great!",
    },
    34: {
      title: "The lesson will take place on our platform 💻",
      typeInfo: "classroom",
      subtitle:
        "You'll get a link and a unique code via WhatsApp and email. Just click the link, it will take you straight to the lesson. No extra apps, no downloads.",
      button: "Got it ✅",
    }
  },
};